import { Divider, Typography, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import { formatDate, NotificationType } from 'constants/notifications.constants';
import { useAppSelector } from 'hooks/redux.hooks';
import _ from 'lodash';
import { useMemo } from 'react';
import { selectTranslations } from 'state/reducers/translation.reducers';

export default function NotificationItem({ handleClose, notification }) {
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);

	const notificationText = useMemo(() => {
		switch (notification.type) {
			case NotificationType.Balance:
				return t(
					`header.notifications.balance.${_.snakeCase(notification.relatedRequest?.type)}.${_.snakeCase(
						notification?.status
					)}.text`
				);
			case NotificationType.Contact:
			case NotificationType.BankAccount:
			case NotificationType.Payment:
			case NotificationType.Beneficiary:
			case NotificationType.SupportRequest:
				return t(
					`header.notifications.${_.snakeCase(notification.type)}.${_.snakeCase(notification?.status)}.text`
				);
		}
	}, [notification]);
	return (
		<>
			<Box
				dir="rtl"
				sx={{
					marginTop: '0!important',
					width: '100%',
					padding: '8px 15px 0 15px',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-between',
					background: notification.readBy ? theme.palette.root.basicWhite : theme.palette.root.darkGrayed_028,
				}}
			>
				<Box sx={{ paddingBottom: '8px' }}>
					<Typography
						variant="boldMedium"
						sx={{
							color: notification.readBy
								? theme.palette.root.basicDeepBlue
								: theme.palette.root.brandSecondary,
						}}
					>
						{t(`header.notifications.titles.${_.snakeCase(notification.type)}.text`)}
					</Typography>
					<Box sx={{ display: 'flex', flexDirection: 'column' }}>
						<Typography variant="lightSmall" sx={{ color: theme.palette.root.ux07777 }}>
							{notificationText}
						</Typography>
						<Typography variant="lightSmall" sx={{ color: theme.palette.root.ux07777 }}>
							{formatDate(notification.createdAt)}
						</Typography>
					</Box>
				</Box>
				<Divider />
			</Box>
		</>
	);
}
